import { Text } from "@chakra-ui/react";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = { schoolForm: { rank: number | null } | null };
export function buildSchoolRankColumnDef<
  T extends Row
>(): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.schoolForm?.rank,
    id: ColumnId.SchoolRank,
    header: "Rank",
    tooltip: "Sort by rank",
    cell: (props) =>
      getDisplayRank(props.row.original.schoolForm?.rank) ?? (
        <Text variant="placeholder">No rank</Text>
      ),
  };
}

function getDisplayRank(rank: number | null | undefined) {
  return typeof rank === "number" ? rank + 1 : null;
}
